import { render, staticRenderFns } from "./UpdateSystem.vue?vue&type=template&id=11ada098&scoped=true"
import script from "./UpdateSystem.vue?vue&type=script&lang=ts"
export * from "./UpdateSystem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ada098",
  null
  
)

export default component.exports